import { FC } from 'react';
import getClassNames from 'src/common/utils/getClassNames';
import styles from './Modal.module.scss';

type DescriptionProps = {
  children: React.ReactNode;
  classNameModifier?: string;
};

const Description: FC<DescriptionProps> = ({ children, classNameModifier }) => (
  <p className={getClassNames(styles, 'description', classNameModifier)}>
    {children}
  </p>
);

export default Description;
